<template>
    <div class="voteBox">
        <div class="mapbox" v-for="(it,index) in assList" :key="index">
            <div class="headerTop">
                票面信息{{index+1}}
                <P class="rigsX" v-if="index!=0" @click="handleDel(index)">×</P>
            </div>
            <el-row class="voteTop">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">

                    <!-----        选择票据类型            ------->
                    <el-form-item label="选择票据类型：" prop="name" class="reds">
                        <el-radio-group v-model="it.billType">
                            <el-radio label="银票">银票</el-radio>
                            <el-radio label="商票">商票</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <!-----        上传票面信息            ------->
                    <el-form-item label="上传票面：" prop="type">
                        <div class="fonts">
                            支持图片格式：JPG,PNG,GIF,JPEG, 图片大小不超过1.5M
                        </div>
                        <el-col :span="6" class="upd">
                            <el-upload
                                class="upload-demo"
                                drag
                                :limit=1
                                ref="uploadFileFpx"
                                action="https://jsonplaceholders.typicode.com/posts/"
                                :http-request="uploadFileFpx"
                                :data={index:index}
                                :on-remove="()=>handleRemFpx(index)"
                                >
                                <div style="width:100%;height:100%;z-index:1000" v-if="it.billFrontUrl!=''" >
                                    <img style="width:100%;height:100%;z-index:1000"   :src="it.billFrontUrl" alt="" @click.stop="handlePreFpx(index)">
                                    <div class="occr" @click.stop="handleSco">
                                                            <div class="bigview iconfont icon-browse" @click.stop="handlePreFpx(index)">
                                                                <i class="el-icon-view"></i>
                                                                <p>查看大图</p>
                                                            </div>
                                                            <div class="delpic "  @click.stop="handleRemFpx(index)">
                                                                <i class="el-icon-delete"></i>
                                                                <p>删除重传</p>
                                                                </div>
                                    </div>
                                </div>
                                <div style="width:100%;height:100%;z-index:1000" v-else>
                                    <div style="width:30%;height:10%;z-index:1000;margin:auto" v-if="it.zgvisible">
                                        <img style="width:100%;height:100%;z-index:1000"   src="../../assets/wait.gif" alt=""  class="waits">
                                    </div>
                                    <div class="jkl" v-else>
                                        <i class="el-icon-upload oppl"></i>
                                        <p>上传电票正面</p>
                                    </div>
                                </div>
                                <div class="el-upload__tips" slot="tip">电票正面截图<span @click="handleShowAlso('1')" class="showAlso">查看示例</span></div>
                            </el-upload>
                            <el-dialog :visible.sync="it.diaFpx" append-to-body>
                                <img width="100%" :src="it.billFrontUrl" alt="">
                            </el-dialog>
                        </el-col>
                        <el-col :span="6" class="upd">
                            <el-upload
                                class="upload-demo"
                                drag
                                :limit=1
                                ref="uploadFileTes"
                                :data={index:index}
                                action="https://jsonplaceholders.typicode.com/posts/"
                                :http-request="uploadFileTes"
                                :on-remove="()=>handleRemTes(index)"
                                >
                                <div style="width:100%;height:100%;z-index:1000" v-if="it.billBackUrl!=''" >
                                    <img style="width:100%;height:100%;z-index:1000"   :src="it.billBackUrl" alt="" @click.stop="handlePreTes(index)">
                                    <div class="occr" @click.stop="handleSco">
                                                            <div class="bigview iconfont icon-browse" @click.stop="handlePreTes(index)">
                                                                <i class="el-icon-view"></i>
                                                                <p>查看大图</p>
                                                            </div>
                                                            <div class="delpic "  @click.stop="handleRemTes(index)">
                                                                <i class="el-icon-delete"></i>
                                                                <p>删除重传</p>
                                                                </div>
                                    </div>
                                </div>
                                <div style="width:100%;height:100%;z-index:1000" v-else>
                                    <div style="width:30%;height:10%;z-index:1000;margin:auto" v-if="it.bmvisible">
                                        <img style="width:100%;height:100%;z-index:1000"   src="../../assets/wait.gif" alt=""  class="waits">
                                    </div>
                                    <div class="jkl" v-else>
                                        <i class="el-icon-upload oppl"></i>
                                        <p>上传电票背面</p>
                                    </div>
                                </div>
                                <div class="el-upload__tips" slot="tip">电票背面截图<span @click="handleShowAlso('2')" class="showAlso">查看示例</span></div>
                            </el-upload>
                            <el-dialog :visible.sync="it.diaTes" append-to-body>
                                <img width="100%" :src="it.billBackUrl" alt="">
                            </el-dialog>
                        </el-col>
                        <el-col :span="24" class="titso">
                            提示：图片上传后会自动识别票面票号、承兑人、金额和到期日，如信息有误，请手动修改
                        </el-col>
                        <el-col :span="7" class="inpusBox">
                            <P>票号:</P>
                            <el-input v-model="it.billNum" placeholder="请输入票号"></el-input>
                        </el-col>
                        <el-col :span="7" class="inpusBox">
                            <P>承兑人名称:</P>
                            <el-input v-model="it.acceptingBank" placeholder="请输入承兑人名称"></el-input>
                        </el-col>
                        <el-col :span="6" class="inpusBox">
                            <P>承兑行行号:</P>
                            <el-input class="bankNumber" v-model="it.acceptingOpenBankCode" placeholder="请输入承兑行行号"></el-input>
                        </el-col>
                        <el-col :span="7" class="inpusBox">
                            <P>票面金额:</P>
                            <el-input v-model="it.billAmt" placeholder="请输入票面金额（单位：元）"></el-input>
                        </el-col>
                        <el-col :span="7" class="inpusBox">
                            <P>到期日:</P>
                            <el-date-picker
                                v-model="it.endDate"
                                :clearable='false'
                                value-format='yyyy-MM-dd'
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>

                    <!-----        瑕疵情况            ------->
                    <el-form-item label="瑕疵情况：" prop="name">
                        <el-checkbox-group v-model="it.billFeature">
                            <el-checkbox label="无瑕疵" name="type">无瑕疵</el-checkbox>
                            <el-checkbox label="回头" name="type">回头</el-checkbox>
                            <el-checkbox label="重复" name="type">重复</el-checkbox>
                            <el-checkbox label="质押" name="type">质押</el-checkbox>
                            <el-checkbox label="保证" name="type">保证</el-checkbox>
                            <el-checkbox label="保理" name="type">保理</el-checkbox>
                            <el-checkbox label="上下不一致" name="type">上下不一致</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <!-----        背书手数：            ------->
                    <el-form-item label="背书手数：" prop="name">
                        <el-input-number v-model="it.bsSs" @change="handleChange" :min="0"  label="描述文字"></el-input-number>
                    </el-form-item>

                    <!-----        流转时限：            ------->
                    <el-form-item label="流转时限：" prop="name">
                        <el-col :span="24">
                            <el-col :span="2">
                                背书时限
                            </el-col>
                            <el-col :span="4" class="selbox">
                                <el-select v-model="it.overHour" placeholder="请选择">
                                    <el-option
                                    v-for="item in optionsOne"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                小时
                                <el-tooltip class="item" effect="dark" content="受让方付款后，您需在此时限内完成背书，否则将记您违约一次" placement="top-start">
                                    <i class="el-icon-warning-outline"></i>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="2">
                                签收时限
                            </el-col>
                            <el-col :span="4" class="selbox">
                                <el-select v-model="it.overHourBuy" placeholder="请选择">
                                    <el-option
                                    v-for="item in optionsTwo"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                小时
                                <el-tooltip class="item" effect="dark" content="您完成背书在平台确认后，您可要求受让方在此时限内签收，否则将记受让方违约一次" placement="top-start">
                                    <i class="el-icon-warning-outline"></i>
                                </el-tooltip>
                            </el-col>
                            <!-- <el-col :span="11" class="selfont">
                                （注：如受让方已付款，您需在此时限内完成背书，否则将记您违约一次）
                            </el-col> -->
                        </el-col>
                    </el-form-item>

                    <!-----        有效期：            ------->
                    <el-form-item label="有效期：" prop="type">
                        <el-col :span="6">
                            <el-date-picker
                                    v-model="it.effectiveDate"
                                    :clearable='false'
                                    value-format='yyyy-MM-dd'
                                    type="date"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-col>
                        <el-col :span="11" class="selfont">
                            （注：如有效期当日20:00后仍未被接单，平台将自动关闭此订单）
                        </el-col>
                    </el-form-item>

                    <!-----        交易账户：            ------->
                    <el-form-item label="交易账户：" prop="type">
                        <el-col :span="24" class="olkbox">
                            <el-select class="odvs" v-model="it.acctVirtualId" placeholder="请选择您交易所用的账户">
                                <el-option
                                    v-for="item in optionsName"
                                    :key="item.id"
                                    :label="item.cmpName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-form-item>

                    <!-----        一口价：            ------->
                    <el-form-item label="一口价：" prop="type">
                        <el-col :span="8" class="priceInput">
                            <span>每十万扣款：</span><el-input @input="handleInput(index)" v-model="it.tenThousandDiscount" maxlength=6 placeholder="请输入金额"></el-input>元
                        </el-col>
                        <el-col :span="8" class="priceInput">
                            <span>年化：</span><span class="redspan">{{it.channelYearRate}}</span>
                        </el-col>
                        <el-col :span="8" class="priceInput">
                            <span>到账金额：</span><span class="redspan">{{it.money}}</span>
                        </el-col>
                    </el-form-item>
                </el-form>
                <el-dialog
                    title="请输入验证码"
                    :visible.sync="dialogV"
                    :before-close="handleClose"
                    width="380px"
                    >
                        <el-input v-model="inputVal" placeholder="请输入验证码" ></el-input>
                        <P class="diaP">我们向您的手机发送验证码确认此次信息，超时请点击<el-button class="diaSpan" :disabled="disa" @click="handleAgain">{{btntxt}}</el-button></P>
                        <div class="bud">
                            <el-button type="primary" class="butg"  @click="submitForm()">确认</el-button>
                        </div>
                </el-dialog>

                <el-dialog
                    title="定向发布"
                    :visible.sync="pushBoolen"
                    :before-close="handleClose"
                    width="380px"
                    >
                        <P class="srf">受让方手机号</P>
                        <el-input v-model="inputPhoneVal" placeholder="请输入受让方手机号" ></el-input>
                        <P class="srf">受让方姓名</P>
                        <el-input v-model="inputNameVal" placeholder="请输入受让方姓名" ></el-input>
                        <div class="bud">
                            <el-button type="primary" class="butg"  @click="submitForm()">确定发布</el-button>
                        </div>
                </el-dialog>

                <el-dialog
                    :visible.sync="showGet"
                    width="350px"
                    :show-close='false'
                    :close-on-click-modal='false'
                    center>
                    <div class="getbox">
                        <P class="getP">您已发布成功，平台正在审核，审核通过后订单将会出现在服务大厅</P>
                        <el-row>
                            <!-- <el-col :span="12">
                                <el-button type="primary" class="but11"  @click="handleGetNew()">继续添加</el-button>
                            </el-col> -->
                            <el-col :span="24">
                                <el-button type="primary" class="but22"  @click="handleGetBuy()">确认</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </el-dialog>

                <el-dialog
                    title="《票据应收款转让服务协议》"
                    :visible.sync="dialog"
                    width="950px"
                >
                    <div class="treeCon">
                        <embed
                            :src="pdfurl"
                            type="application/pdf"
                            class="emb"
                        />
                    </div>
                </el-dialog>

                <el-dialog
                    :visible.sync="showImg1"
                    width="650px"
                    center>
                    <img src="../../assets/showpa.jpg" alt="" class='uzi'>
                </el-dialog>

                <el-dialog
                    :visible.sync="showImg1"
                    width="650px"
                    center>
                    <img src="../../assets/showpa.jpg" alt="" class='uzi'>
                </el-dialog>

                <el-dialog
                    :visible.sync="showImg2"
                    width="650px"
                    center>
                    <img src="../../assets/showba.jpg" alt="" class='uzi'>
                </el-dialog>
            </el-row>
        </div>
        <el-col :span="24" class="agree" >
            <el-checkbox v-model="checkeds" @change="handleCheckVal">请阅读并同意此协议<span class="fuwu" @click.stop="handleShow">《票据应收款转让服务协议》</span></el-checkbox>
        </el-col>
        <el-col :span="24" class="agree" >
            <el-button type="primary"   @click="getAdd()">继续添加</el-button>
            <el-button type="primary" :loading="buLod" :disabled="disabled" @click="handlePush()">立即发布</el-button>
            <el-button type="primary" :loading="buLod" :disabled="disabled" @click="truePush()">定向发布</el-button>
        </el-col>
    </div>
</template>

<script>
export default {
    data(){
        return{
            buLod:false,
            showGet:false,
            billFrontUrl:'',                //电票证明参数
            diaFpx:false,
            zgvisible:false,          //
            billBackUrl:'',                //电票背面参数
            diaTes:false,
            bmvisible:false,         //
            checkeds:'',
            billType:'银票',            //票据类型参数
            billNum:'',              //票号参数
            acceptingBank:'',             //承兑人名称
            acceptingOpenBankCode:'',              //承兑行行号
            billAmt:'',            //票面金额
            endDate:'',             //票面日期
            billFeature:[],            //瑕疵i情况数据
            bsSs:0,                //背书手数次数
            overHour:'',         //背书实现参数
            optionsOne:[{
                value: '0.5',
                label: '0.5'
                }, {
                value: '1.0',
                label: '1.0'
                }, {
                value: '1.5',
                label: '1.5'
                }, {
                value: '2.0',
                label: '2.0'
                }, {
                value: '2.5',
                label: '2.5'
                },{
                    value: '3.0',
                    label: '3.0'
                }
            ],
            overHourBuy:'',         //签收时限参数
            optionsTwo:[{
                value: '0.5',
                label: '0.5'
                }, {
                value: '1.0',
                label: '1.0'
                }, {
                value: '1.5',
                label: '1.5'
                }, {
                value: '2.0',
                label: '2.0'
                }
            ],
            effectiveDate:'',           //有效期参数
            acctVirtualId:'',               //交易账户参数
            optionsName: [],
            tenThousandDiscount:'',              //每十万扣款参数
            ruleForm: {
            },
            rules: {
                name: [
                    { required: false, message: '请输入活动名称', trigger: 'blur' },
                    { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                type: [
                    { type: 'array', required: false, message: '请至少选择一个活动性质', trigger: 'change' }
                ],
            },
            assList:[
                {
                    billType:'银票',
                    billFrontUrl:'',
                    zgvisible:false,
                    diaFpx:false,
                    billBackUrl:'',
                    bmvisible:false,
                    diaTes:false,
                    billNum:'',
                    acceptingBank:'',
                    acceptingOpenBankCode:'',
                    billAmt:'',
                    endDate:'',
                    billFeature:[],
                    bsSs:0,
                    overHour:'',
                    overHourBuy:'',
                    effectiveDate:'',
                    acctVirtualId:'',
                    tenThousandDiscount:'',
                    channelYearRate:'',
                    money:''
                }
            ],
            channelYearRate:'',
            money:'',
            oneJsonData:{},
            oneImgUrl:'',
            twoImgUrl:'',
            pushVal:'0',
            showInput:false,
            poshPhone:'',
            poshName:'',
            disabled:true,
            dialog:false,
            dialogV:false,
            inputVal:'',
            showImg1:false,
            showImg2:false,
            btntxt:'再次发送',
            time:120,
            disa:false,
            pdfurl:'',
            pushBoolen:false,
            inputPhoneVal:'',
            inputNameVal:''
        }
    },
    mounted(){
        this.handleAjax()
    },
    methods: {
        handleAjax(){
            this.ajax.post('/merchant/getmerchant',{bizContent:{merchantCode:'dianpiaobao'}})
                            .then(
                                result=>{
                                    if(result.data.status=='0000'){
                                        this.pdfurl=result.data.data.transferserviceurl
                                    }else{
                                        this.$message({
                                                type: 'warning',
                                                duration:5000,
                                                message: result.data.message,
                                                center: true,
                                                offset:300
                                        });
                                    }
                                }
                    )
            let bizContent={}
            bizContent.uid=this.$route.query.uid
            this.ajax.post(this.versatile.dpburl+'/jyorder/getJYACCT',{bizContent})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.optionsName=result.data.data.listCmp
                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
        },
        handlePush(){
            this.ajax.post(this.versatile.dpburl+'/jyorder/moreBillValidate',{bizContent:{uid:this.$store.state.userId,billList:this.assList}})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                let bizContent={}
                                bizContent.uid=this.$store.state.userId
                                bizContent.submitType='0'
                                bizContent.channelPhone=this.inputPhoneVal
                                bizContent.channelName=this.inputNameVal
                                bizContent.billList=this.assList
                                this.ajax.post('/jyorder/addOrderNewAdd',{bizContent})
                                        .then(
                                            result=>{
                                                if(result.data.status=='0000'){
                                                    this.dialogV=false
                                                    this.showGet=true
                                                    this.handleAjax()
                                                }else{
                                                    this.$message({
                                                            type: 'warning',
                                                            duration:5000,
                                                            message: result.data.message,
                                                            center: true,
                                                            offset:300
                                                    });
                                                }
                                            }
                                )
                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
        },
        truePush(){
            this.pushBoolen=!this.pushBoolen
        },
        submitForm() {
            this.ajax.post(this.versatile.dpburl+'/jyorder/moreBillValidate',{bizContent:{uid:this.$store.state.userId,billList:this.assList}})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                let bizContent={}
                                bizContent.uid=this.$store.state.userId
                                bizContent.submitType='1'
                                bizContent.channelPhone=this.inputPhoneVal
                                bizContent.channelName=this.inputNameVal
                                bizContent.billList=this.assList
                                this.ajax.post('/jyorder/addOrderNewAdd',{bizContent})
                                        .then(
                                            result=>{
                                                if(result.data.status=='0000'){
                                                    this.$message({
                                                        type: 'success',
                                                        duration:5000,
                                                        message: '发布成功，正在跳转！',
                                                        center: true,
                                                        offset:300
                                                    });
                                                    this.$router.push({
                                                        name:'Exchangetrue'
                                                    })
                                                }else{
                                                    this.$message({
                                                            type: 'warning',
                                                            duration:5000,
                                                            message: result.data.message,
                                                            center: true,
                                                            offset:300
                                                    });
                                                }
                                            }
                                )
                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
        },
        handleAgain(){
            this.ajax.post(this.versatile.oaurl+'/sms/sendSms',{bizContent:{mobile:this.$store.state.userInfor,type:'pjjyfb'}})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message({
                                        type: 'success',
                                        duration:5000,
                                        message: '验证码已发送至您的手机上',
                                        center: true,
                                        offset:300
                                });
                                this.time=120;
                                this.disa=true
                                this.timer();
                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
                )
        },
        timer:function () {
            if (this.time > 0) {
                this.time--;
                this.btntxt=this.time+"s后重新获取";
                setTimeout(this.timer, 1000);
                this.disa=true;
            } else{
                this.time=0;
                this.btntxt="再次发送";
                this.disa=false;
            }
        },
        uploadFileFpx(item){
            let index=item.data.index
            this.zgvisible=true
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            this.ajax.post(this.versatile.dpburl+'/ocr/note',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                // this.oneJsonData=result.data.data
                                this.assList[index].billNum=result.data.data.note_code
                                this.assList[index].acceptingBank=result.data.data.acceptor_name
                                this.assList[index].acceptingOpenBankCode=result.data.data.acceptor_open_bank_no
                                this.assList[index].billAmt=result.data.data.note_price
                                this.assList[index].endDate=result.data.data.note_end_date

                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
            this.ajax.post(this.versatile.oaurl+'/upload/fastdfsUpload',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.assList[index].zgvisible=false
                                let url = 'https://img.dianpiaobao.com/'+result.data.data
                                this.assList[index].billFrontUrl=url
                                this.assList[index].oneImgUrl=result.data.data
                                this.$message({
                                        type: 'success',
                                        duration:5000,
                                        message: '提交成功！',
                                        center: true,
                                        offset:300
                                });
                            }else{
                                this.assList[index].zgvisible=false
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
        },
        uploadFileTes(item){
            this.bmvisible=true
            let index=item.data.index
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            this.ajax.post(this.versatile.dpburl+'/ocr/idcardBack',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                // this.validityAgent=result.data.data.validity
                                // this.issue_authority_agent=result.data.data.issue_authority
                                this.$message({
                                        type: 'success',
                                        duration:5000,
                                        message: '提交成功！',
                                        center: true,
                                        offset:300
                                });
                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
            this.ajax.post(this.versatile.oaurl+'/upload/fastdfsUpload',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.assList[index].bmvisible=false
                                let url = 'https://img.dianpiaobao.com/'+result.data.data
                                this.assList[index].billBackUrl=url
                                this.assList[index].twoImgUrl=result.data.data
                            }else{
                                this.assList[index].bmvisible=false
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
        },
        handleRemFpx(index) {
            this.$refs.uploadFileFpx[index].clearFiles();
            this.assList[index].zgvisible=false
            this.assList[index].billFrontUrl=''
            this.assList[index].billNum=''
            this.assList[index].acceptingBank=''
            this.assList[index].acceptingOpenBankCode=''
            this.assList[index].billAmt=''
            this.assList[index].endDate=''
        },
        handleRemTes(index) {
            this.$refs.uploadFileTes[index].clearFiles();
            this.assList[index].bmvisible=false
            this.assList[index].billBackUrl=''
        },
        handlePreFpx(index){
            this.assList[index].diaFpx = true;
        },
        handlePreTes(index){
            this.assList[index].diaTes = true;
        },
        handleCheckVal(val){
            if(val == true){
                this.disabled = false
            }else{
                this.disabled = true
            }
        },
        handleValName(e){
            let val = e.target.value
            let reg = /^1[3456789]\d{9}$/;
            if(val!=''){
                if(!reg.test(val)){
                    this.$message('请输入正确的手机号');
                    return;
                }else{
                    this.ajax.post(this.versatile.dpburl+'/jyorder/validateAuth',{bizContent:{channelPhone:val}})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
                    )
                }
            }
        },
        handleInput(index){
            if(this.assList[index].billAmt==''){
                this.$message({
                                type: 'warning',
                                duration:5000,
                                message: '请先输入票面金额',
                                center: true,
                                offset:300
                                });
                this.assList[index].tenThousandDiscount=''
                return;
            }else if(this.assList[index].endDate==''){
                this.$message({
                                type: 'warning',
                                duration:5000,
                                message: '请先输入票面到期日',
                                center: true,
                                offset:300
                                });
                this.assList[index].tenThousandDiscount=''
                return;
            }else{
                let bizContent={}
                bizContent.mswkx=this.assList[index].tenThousandDiscount
                bizContent.rate=''
                bizContent.billAmt=this.assList[index].billAmt
                bizContent.endDate=this.assList[index].endDate
                this.ajax.post(this.versatile.dpburl+'/jyorder/getZKLORRATE',{bizContent})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                // this.tenThousandDiscount=this.numFormat(val.replace(/,/gi, ''))
                                this.assList[index].channelYearRate=result.data.data.rate
                                this.assList[index].money=result.data.data.getMony+'元'

                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
            }
        },
        numFormat(num){
            let res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                    return $1+",";
                    });
            })
            return res;
        },
        handleRadioChange(val){
            if(val=='1'){
                this.showInput=true
            }else{
                this.showInput=false
            }
        },
        handleShowAlso(val){
            if(val=='1'){
                this.showImg1=!this.showImg1
            }else{
                this.showImg2=!this.showImg2
            }
        },
        handleChange(value) {
            
        },
        handleShow(){
            this.dialog=!this.dialog
        },
        handleSco(){

        },
        handleGetBuy(){
            this.$router.push({
                path:'/pageOrder',
                query:{
                    us:'ao'
                }
            })
        },
        getAdd(){
            let bizContent={}
            bizContent.uid=this.$route.query.uid
            bizContent.billList=this.assList
            this.ajax.post(this.versatile.dpburl+'/jyorder/moreBillValidate',{bizContent})
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                let add= {
                                    billType:'银票',
                                    billFrontUrl:'',
                                    zgvisible:false,
                                    diaFpx:false,
                                    billBackUrl:'',
                                    bmvisible:false,
                                    diaTes:false,
                                    billNum:'',
                                    acceptingBank:'',
                                    acceptingOpenBankCode:'',
                                    billAmt:'',
                                    endDate:'',
                                    billFeature:[],
                                    bsSs:0,
                                    overHour:'',
                                    overHourBuy:'',
                                    effectiveDate:'',
                                    acctVirtualId:'',
                                    tenThousandDiscount:'',
                                    channelYearRate:'',
                                    money:''
                                }
                                this.assList.push(add);
                            }else{
                                this.$message({
                                        type: 'warning',
                                        duration:5000,
                                        message: result.data.message,
                                        center: true,
                                        offset:300
                                });
                            }
                        }
            )
        },
        handleDel(index){
            this.assList.splice(index,1);
        },
        handleGetNew(){
            this.billType=''
            this.billFrontUrl=''
            this.billBackUrl=''
            this.billNum=''
            this.acceptingBank=''
            this.acceptingOpenBankCode=''
            this.billAmt=''
            this.endDate=''
            this.billFeature=[]
            this.bsSs=0
            this.overHour=''
            this.overHourBuy=''
            this.acctVirtualId=''
            this.tenThousandDiscount=''
            this.channelYearRate=''
            this.money=''
            this.pushVal='0'
            this.effectiveDate=''
            this.poshPhone=''
            this.poshName=''
            this.inputVal=''
            this.tableData=[]
            this.showGet=false
            this.handleRemTes()
            this.handleRemFpx()
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
                this.time=0;
                this.btntxt="再次发送";
                this.disa=false;
            })
            .catch(_ => {});
        },
    },
}
</script>

<style  scoped>
.voteBox{
    background: #fff;
    height: auto;
    overflow: hidden;
    padding: 0 20px 10px;
}
.headerTop{
    height: 40px;
    line-height: 40px;
    width: 100%-10px;
    padding-left: 10px;
    background: #3E5F9C;
    margin-top: 10px;
    color: #fff;
    font-size: 16px;
    overflow: hidden;
}
.el-tabs__content{
    padding: 0!important;
}
.el-input__inner{
    height: 40px!important;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.voteTop{
    padding: 10px 0px;
}
.voteTop>>>.el-form-item{
    margin: 0;
    border-bottom: 1px solid #eee;
    background: #F0EFEF;
}
.voteTop>>>.el-form-item__label{
    /* background: #F0EFEF; */
    padding: 10px 0;
    text-align: center!important;
}
.voteTop>>>.el-form-item__content{
    padding: 10px 0 10px 20px;
    background: #fff;
    padding-top: 15px;
}
.el-upload__tips{
    text-align: center;
}
.titso{
    color: #FF5959;
    font-size: 14px;
}
.inpusBox{
    margin-right: 40px;
    margin-bottom: 10px;
}
.inpusBox>>>.el-input{
  width: 297px;
  /* margin-right: 50px; */
}
.bankNumber{
  width: 200px!important;
}
.new{
    margin: 10px 0;
    font-size: 14px;
}
.fonts{
    color: #999999;
    font-size: 14px;
}
.upd{
    margin-right: 30px;
}
.upd>>>.el-upload-dragger{
    width: 300px;
    height: 160px;
}
.upd>>>.el-upload--picture-card{
    border: none;
}
.upd>>>.el-upload-list__item{
    width: 300px;
}
.upd>>>.el-upload-dragger{
    margin-top: 5px;
}
.upd>>>.el-icon-upload{
    margin: 0;
}
.selbox{
    margin-right: 10px;
}
.selfont{
    font-size: 12px;
    color: #999999;
}
.selbox>>>.el-input__inner{
    width: 100px;
}
.olkbox>>>.el-input__inner{
    width: 300px;
}
.priceInput>>>.el-input{
    width: 130px;
    margin-right: 3px;
}
.agree{
    margin-top: 20px;
    font-size: 14px;
    text-align: center;
}
.fuwu{
    color: #4C8BF0FF;
}
.waits{
    margin-top: 70px!important;
}
.occr{
    width: 100%;
    height: 100%;
    z-index: 1001;
    background: #000;
    opacity:0.3;
    position: absolute;
    top: 0px;
    left: 0;
}
.occr{
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    opacity: 0;
    transition: opacity .3s ease-in;
}
.occr:hover{
    opacity: 1;
    transition: opacity .3s ease-in;
}
.bigview{
    float: left;
    margin-top: 40px;
    margin-left: 50px;
    height: 100%;
}
.delpic{
    float: right;
    margin-top: 40px;
    margin-right: 50px;
    height: 100%;
}
.diaP{
    margin-top: 10px;
    font-size: 14px;
    color: #0000002B;
}
.diaSpan{
    color: #409EFF;
    border: none;
    padding: 0;
}
.diaSpan:hover{
    cursor: pointer;
}
.bud{
    text-align: center;
    margin-top: 20px;
}
.butg{
    background: #3E5F9CFF;
    color: #fff;
}
.jkl{
    padding-top: 40px;
    color: #999999FF;
}
.showAlso{
    color: #59AEFFFF;
    margin-left: 10px;
}
.showAlso:hover{
    cursor: pointer;
}
.uzi{
    height: 100%;
    width: 100%;
    margin-bottom: 5px;
}
.getbox{
    text-align: center;
}
.getP{
    font-size: 16px;
    color: #333333FF;
    margin-bottom: 20px;
}
.but11{
    width: 100px;
    border:1px solid  #3E5F9CFF;
    background: #fff;
    color: #3E5F9CFF;
}
.but22{
    width: 100px;
    border:1px solid  #3E5F9CFF;
    background: #3E5F9CFF;
    color: #fff;
}
.redspan{
    color: red;
    font-weight: 600;
}
.reds{
    color: red!important;
}
.treeCon{
    margin-top: 0px;
    height: 626px;
    width: 880px;
    margin-bottom: 10px;
    /* background: #F4F6F8FF; */
}
.emb{
    height: 100%;
    width: 100%;
    margin: auto;
}
.rigsX{
    float: right;
    font-size: 20px;
    margin-right: 20px;
    color: ##fff;
}
.rigsX:hover{
    cursor: pointer;
}
.srf{
    font-size: 14px;
    color: #333;
    margin: 10px;
}
.oppl{
    font-size: 32px;
}
/* .odvs{
    border: 1px solid red;
} */
</style>


// WEBPACK FOOTER //
// src/page/orderexception/release.vue